<p-toast></p-toast>
<p-table
    #dt1
    responsiveLayout="scroll"
    [value]="data"
    [rowHover]="true"
    dataKey="id"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="true"
    [globalFilterFields]="['name', 'phoneNumber', 'datePrice', 'dateDuration', 'email']"
>
    <ng-template pTemplate="caption">
        @if (!global) {
            <div class="flex justify-content-between align-content-center flex-wrap">
                <p-button
                    [label]="'Añadir Especialistas a ' + clinic?.name"
                    (click)="add()"
                    icon="pi pi-plus"
                    onKeyPress=""
                />
                <span class="p-input-icon-left mb-2">
        <i class="pi pi-search"></i>
        <input
            pInputText
            type="text"
            #filter
            (input)="onGlobalFilter(dt1, $event)"
            placeholder="Buscar"
            class="w-full"
        />
      </span>
            </div>
        }
        @if (global) {
            <div class="flex justify-content-end align-content-center flex-wrap">
      <span class="p-input-icon-left mb-2">
        <i class="pi pi-search"></i>
        <input
            pInputText
            type="text"
            #filter
            (input)="onGlobalFilter(dt1, $event)"
            placeholder="Buscar"
            class="w-full"
        />
      </span>
            </div>
        }
    </ng-template>

    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="name" scope="col">
                Especialista
                <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th scope="col">Email</th>
            <th class="text-center" scope="col">Especialidad</th>
            <th class="text-center" scope="col">Teléfono</th>
            <th class="text-center" scope="col">Disponibilidad</th>
            <th class="text-center" scope="col" [ngClass]="{ hidden: appName === 'Caser MIMAvet' }">
                Precio por minutos
            </th>
            <th class="text-center" scope="col"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr>
            <td>
                <ng-container *ngIf="data.imageUrl; else noDataImage">
                    <p-avatar
                        [image]="data.imageUrl"
                        shape="circle"
                        [style]="{ 'background-color': '#00929c', color: '#fff', 'vertical-align': 'middle' }"
                    />
                </ng-container>
                <ng-template #noDataImage>
                    <p-avatar
                        [style]="{ 'background-color': '#00929c', color: '#fff', 'vertical-align': 'middle' }"
                        [label]="data.name.charAt(0).toUpperCase()"
                        shape="circle"
                    />
                </ng-template>
                <span class="image-text ml-2">{{ data.name }}</span>
            </td>
            <td>
                {{ data.email ?? '-' }}
            </td>
            <td class="text-center">
                {{ data.specialty }}
            </td>
            <td class="text-center">
                <ng-container *ngIf="data.phoneNumber; else noDataPhone">
                    <a [href]="'tel:' + data.phoneNumber"> {{ data.phoneNumber }}</a>
                </ng-container>
                <ng-template #noDataPhone>-</ng-template>
            </td>
            <td class="text-center">
                <ng-container *ngIf="data.available; else noDataAvailable">
                    <i class="pi pi-check-circle" style="color: var(--text-success)"></i>
                </ng-container>
                <ng-template #noDataAvailable
                ><i class="pi pi-times-circle" style="color: var(--text-danger)"></i
                ></ng-template>
            </td>
            <td class="text-center" [ngClass]="{ hidden: appName === 'Caser MIMAvet' }">
                <ng-container *ngIf="data.datePrice && data.dateDuration; else noDataPrice">
                    {{ data.datePrice | currency : 'EUR' : 'symbol' }} por {{ data.dateDuration }} minutos
                </ng-container>
                <ng-template #noDataPrice>-</ng-template>
            </td>
            <td class="text-center">
                <div class="flex">
                    <button
                        pButton
                        pRipple
                        icon="pi pi-eye"
                        class="p-button-rounded p-button mr-2"
                        (click)="view(data)"
                    ></button>
                    @if (!global) {
                        <button
                            pButton
                            pRipple
                            icon="pi pi-times"
                            class="p-button-rounded p-button-warning"
                            (click)="openModalDelete(data)"
                        ></button>
                    }
                    @if (global) {
                        <button
                            pButton
                            pRipple
                            icon="pi pi-file-edit"
                            class="p-button-rounded p-button mr-2"
                            (click)="openModalEdit(data)"
                        ></button>
                        <button
                            pButton
                            pRipple
                            icon="pi pi-trash"
                            class="p-button-rounded p-button mr-2 p-button-danger"
                            (click)="onDeleteSpecialist(data)"
                        ></button>
                    }
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-confirmDialog
    header="Vas a borrar un especialista"
    key="onDeleteSpecialist"
    icon="pi pi-exclamation-triangle"
    [style]="{ width: '350px' }"
    severity="danger"
    acceptButtonStyleClass="p-button-text"
    rejectButtonStyleClass="p-button-text"
></p-confirmDialog>

<p-dialog
    header="Especialista"
    [modal]="true"
    [(visible)]="viewModal"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '30vw' }"
    [contentStyle]="{ overflow: 'visible' }"
>
    <ul class="list-none p-0 m-0">
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-3 font-medium">Nombre</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                <ng-container *ngIf="specialist?.imageUrl; else noDataImageModal">
                    <p-avatar
                        [image]="specialist.imageUrl"
                        shape="circle"
                        size="xlarge"
                        [style]="{ 'background-color': '#00929c', color: '#fff', 'vertical-align': 'middle' }"
                    />
                </ng-container>
                <ng-template #noDataImageModal>
                    <p-avatar
                        [style]="{ 'background-color': '#00929c', color: '#fff', 'vertical-align': 'middle' }"
                        [label]="specialist?.name.charAt(0).toUpperCase()"
                        shape="circle"
                        size="xlarge"
                    />
                </ng-template>
                <span class="image-text mx-2">{{ specialist?.name }}</span>
                <ng-container *ngIf="specialist?.available; else noDataAvailableModal">
                    <i class="pi pi-check-circle" style="color: var(--text-success)"></i>
                </ng-container>
                <ng-template #noDataAvailableModal
                ><i class="pi pi-times-circle" style="color: var(--text-danger)"></i
                ></ng-template>
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-3 font-medium">Email</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                {{ specialist?.email ?? '-' }}
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-3 font-medium">Especialidad</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                {{ specialist?.specialty }}
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-3 font-medium">Currículum</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                {{ specialist?.curriculum ?? '-' }}
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-6 md:w-3 font-medium">Teléfono</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                <ng-container *ngIf="specialist?.phoneNumber; else noDataPhoneModal">
                    <a [href]="'tel:' + specialist.phoneNumber"> {{ specialist.phoneNumber }}</a>
                </ng-container>
                <ng-template #noDataPhoneModal>-</ng-template>
            </div>
        </li>
        @if (appName !== "Caser MIMAvet") {
            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:w-3 font-medium">Precio por minutos</div>
                <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                    <ng-container
                        *ngIf="specialist?.datePrice && specialist?.dateDuration; else noDataPriceModal"
                    >
                        {{ specialist.datePrice | currency : 'EUR' : 'symbol' }} por
                        {{ specialist.dateDuration }} minutos
                    </ng-container>
                    <ng-template #noDataPriceModal>-</ng-template>
                </div>
            </li>
        }
    </ul>
    @if (specialist?.diary) {
        <p-divider />
        <h4 class="text-500 w-6 font-medium text-base ml-2 mt-0">Horario:</h4>
        <ul class="list-none p-0 m-0">
            <li
                class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
                *ngFor="let day of getDiaryDays(specialist?.diary)"
            >
                <div class="text-500 w-6 md:w-3 font-medium md:pl-3">{{ getDayName(day) }}</div>
                <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                    <div class="mb-1" *ngFor="let entry of specialist?.diary[day]">
                        {{ entry.start }}h a {{ entry.end }}h
                    </div>
                </div>
            </li>
        </ul>
    }
</p-dialog>

<p-dialog
    header="Editar Especialista"
    [modal]="true"
    [(visible)]="editModal"
    [breakpoints]="{ '1199px': '85vw', '575px': '90vw' }"
    [style]="{ width: '40vw' }"
    [draggable]="false"
    [resizable]="false"
>
    <ng-template pTemplate="content" #modalNested>
        <form class="p-fluid py-2" [formGroup]="form">
            <div class="field">
                <p-fileUpload
                    accept="image/png, image/jpeg"
                    chooseLabel="Seleccionar imagen"
                    chooseIcon="pi pi-upload"
                    [customUpload]="true"
                    [maxFileSize]="5000000"
                    (uploadHandler)="onUpload($event)"
                    [auto]="true"
                >
                    <ng-template pTemplate="file">
                        @if (selectedFile && previewUrl) {
                            <p-image
                                [src]="previewUrl"
                                alt="Image"
                                width="150"
                                styleClass="flex justify-content-center"
                            />

                        }
                    </ng-template>
                </p-fileUpload>
                @if (specialist.imageUrl && !previewUrl) {
                    <p-image
                        [src]="specialist.imageUrl"
                        alt="Image"
                        width="150"
                        styleClass="flex justify-content-center mt-5"
                    />
                }
                @if (this.form.controls["fileImage"].touched && this.form.controls["fileImage"].dirty &&
                this.form.controls["fileImage"].invalid) {
                    <small class="p-error">Imagen inválida</small>
                }
            </div>
            <div class="field">
        <span class="p-float-label">
          <input id="name" type="text" pInputText formControlName="name" />
          <label for="name">Nombre</label>
        </span>
                <small
                    class="p-error"
                    *ngIf="
            form.controls['name'].touched &&
            form.controls['name'].dirty &&
            form.controls['name'].invalid
          "
                >
                    Campo requerido
                </small>
            </div>

            <div class="field">
        <span class="p-float-label">
          <input id="email" type="text" pInputText formControlName="email" />
          <label for="email">Email</label>
        </span>
                @if (this.form.controls['email'].touched && this.form.controls['email'].dirty &&
                this.form.controls['email'].invalid) {
                    <small class="p-error">Campo requerido</small>
                }
            </div>

            <div class="field">
        <span class="p-float-label">
          <textarea
              id="curriculum"
              inputId="textarea"
              rows="10"
              cols="30"
              formControlName="curriculum"
              pInputTextarea
          ></textarea>
          <label for="inputtext">Currículum</label>
        </span>
                <small
                    class="p-error"
                    *ngIf="
            form.controls['curriculum'].touched &&
            form.controls['curriculum'].dirty &&
            form.controls['curriculum'].invalid
          "
                >
                    Campo requerido
                </small>
            </div>

            <div class="field">
                <span class="block mb-1">Teléfono</span>
                <ngx-intl-tel-input
                    [cssClass]="'p-inputtext p-component p-element min-w-full'"
                    [onlyCountries]="onlyCountries"
                    [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true"
                    [searchCountryFlag]="false"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false"
                    [selectedCountryISO]="CountryISO.Spain"
                    [maxLength]="15"
                    [phoneValidation]="true"
                    [separateDialCode]="true"
                    [numberFormat]="PhoneNumberFormat.National"
                    name="phoneNumber"
                    formControlName="phoneNumber"
                    id="phoneNumber"
                >
                </ngx-intl-tel-input>

                <small
                    class="p-error block"
                    *ngIf="
            form.controls['phoneNumber'].touched &&
            form.controls['phoneNumber'].dirty &&
            form.controls['phoneNumber'].invalid
          "
                >
                    Ingresa un número de teléfono válido
                </small>
            </div>

            <div class="field">
        <span class="p-float-label">
          <input id="specialty" type="text" pInputText formControlName="specialty" />
          <label for="inputtext">Especialidad</label>
        </span>
                <small
                    class="p-error"
                    *ngIf="
            form.controls['specialty'].touched &&
            form.controls['specialty'].dirty &&
            form.controls['specialty'].invalid
          "
                >
                    Campo requerido
                </small>
            </div>

            <div class="field">
        <span class="p-float-label">
          <p-dropdown
              [class]="
              form.controls['dateDuration'].invalid &&
              (form.controls['dateDuration'].dirty || form.controls['dateDuration'].touched)
                ? 'ng-invalid ng-dirty'
                : ''
            "
              [style]="{ 'min-width': '166px' }"
              inputId="dateDuration"
              formControlName="dateDuration"
              [options]="dateMinutes"
              optionLabel="name"
          />
          <label for="selectedDay">Duración de cita</label>
        </span>
                @if (form.controls['dateDuration'].invalid && (form.controls['dateDuration'].dirty ||
                    form.controls['dateDuration'].touched)) {
                    <small class="p-error">Campo requerido</small>
                }
            </div>

            @if (appName !== "Caser MIMAvet") {

                <div class="field">
        <span class="p-float-label">
          <input id="datePrice" type="text" pInputText formControlName="datePrice" />
          <label for="datePrice">Precio de cita</label>
        </span>
                    <small
                        class="p-error"
                        *ngIf="
            form.controls['datePrice'].touched &&
            form.controls['datePrice'].dirty &&
            form.controls['datePrice'].invalid
          "
                    >
                        Campo requerido
                    </small>
                </div>

            }

            <div class="max-w-max mb-2">
                <button
                    pButton
                    pRipple
                    type="button"
                    label="Añadir horario"
                    icon="pi pi-plus"
                    class="p-button-text"
                    (click)="addSchedule()"
                ></button>
            </div>
            @if (diary) {
                <div class="field">
                    <div class="surface-section">
                        <ul class="list-none p-0 m-0">
                            <li
                                *ngFor="let day of getDiaryDays(diary)"
                                class="flex align-items-start py-3 px-2 border-top-1 surface-border flex-wrap"
                            >
                                <div class="text-500 w-6 md:w-2 font-medium mb-2">{{ getDayName(day) }}</div>
                                <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                                    <p-chip
                                        *ngFor="let time of diary[day]"
                                        (onRemove)="onRemoveSchedule(day, time)"
                                        [removable]="true"
                                        [label]="time.start + ' a ' + time.end"
                                        class="mr-2 mb-2 inline-block"
                                    ></p-chip>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            }
        </form>
        <p-dialog
            (onHide)="resetFormNested()"
            [contentStyle]="{ overflow: 'visible' }"
            header="Añadir horario"
            [(visible)]="editModalNested"
            appendTo="modalNested"
            [modal]="true"
            [breakpoints]="{ '1400px': '75vw', '1199px': '75vw', '575px': '90vw' }"

            [draggable]="false"
            [resizable]="false"
        >
            <ng-template pTemplate="content">
                <form [formGroup]="formNested">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-4">
                            <div class="field">
                <span class="p-float-label">
                  <p-dropdown
                      [class]="
                      this.formNested.controls['day'].invalid &&
                      (this.formNested.controls['day'].dirty ||
                        this.formNested.controls['day'].touched)
                        ? 'ng-invalid ng-dirty'
                        : ''
                    "
                      [style]="{ 'min-width': '166px' }"
                      inputId="selectedDay"
                      formControlName="day"
                      [options]="days"
                      optionLabel="name"
                  />
                  <label for="selectedDay">Selecciona el día</label>
                </span>
                                @if (this.formNested.controls['day'].invalid &&
                                (this.formNested.controls['day'].dirty || this.formNested.controls['day'].touched)) {
                                    <small class="p-error">Campo requerido</small>
                                }
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <div class="field">
                <span class="p-float-label">
                  <p-calendar
                      [stepMinute]="15"
                      [readonlyInput]="true"
                      (onShow)="setInitialTimeStartAt()"
                      [class]="
                      this.formNested.controls['startAt'].invalid &&
                      (this.formNested.controls['startAt'].dirty ||
                        this.formNested.controls['startAt'].touched)
                        ? 'ng-invalid ng-dirty'
                        : ''
                    "
                      inputId="startAt"
                      [style]="{ 'max-width': '166px' }"
                      [iconDisplay]="'input'"
                      [showIcon]="true"
                      formControlName="startAt"
                      [timeOnly]="true"
                  >
                    <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
                      <i
                          class="pi pi-clock pointer-events-none"
                          (click)="clickCallBack($event)"
                          onKeyPress=""
                      ></i> </ng-template
                    ></p-calendar>
                  <label for="startAt">Inicio</label>
                </span>
                                @if (this.formNested.controls['startAt'].invalid &&
                                (this.formNested.controls['startAt'].dirty ||
                                    this.formNested.controls['startAt'].touched)) {
                                    <small class="p-error">Campo requerido</small>
                                }
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <div class="field">
                <span class="p-float-label">
                  <p-calendar
                      (onShow)="setInitialTimeEndAt()"
                      [stepMinute]="15"
                      [readonlyInput]="true"
                      [class]="
                      this.formNested.controls['endAt'].invalid &&
                      (this.formNested.controls['endAt'].dirty ||
                        this.formNested.controls['endAt'].touched)
                        ? 'ng-invalid ng-dirty'
                        : ''
                    "
                      inputId="endAt"
                      [style]="{ 'max-width': '166px' }"
                      [iconDisplay]="'input'"
                      [showIcon]="true"
                      formControlName="endAt"
                      [timeOnly]="true"
                  >
                    <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
                      <i
                          class="pi pi-clock pointer-events-none"
                          (click)="clickCallBack($event)"
                          onKeyPress=""
                      ></i> </ng-template
                    ></p-calendar>
                  <label for="endAt">Fin</label>
                </span>
                                @if (this.formNested.controls['endAt'].invalid &&
                                (this.formNested.controls['endAt'].dirty ||
                                    this.formNested.controls['endAt'].touched)) {
                                    <small class="p-error">Campo requerido</small>
                                }
                                @if (formNested.hasError('endAtBeforeStartAt')) {
                                    <small class="p-error"> Fecha fin, debe ser mayor a fecha inicio </small>
                                }
                            </div>
                        </div>
                    </div>
                </form>
            </ng-template>
            <ng-template pTemplate="footer">
                <p-button (click)="onAddSchedule()" icon="pi pi-plus" label="Añadir" onKeyPress="" />
            </ng-template>
        </p-dialog>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button
            [loading]="loading"
            icon="pi pi-check"
            label="Guardar"
            onKeyPress=""
            (click)="save()"
        />
    </ng-template>
</p-dialog>

<p-dialog
    [draggable]="false"
    [resizable]="false"
    [modal]="true"
    [(visible)]="addModal"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '45vw', height: '100vw' }"
>
    @if (specialistsToAdd?.length > 0) {
        <p-table
            styleClass="p-5"
            [value]="specialistsToAdd"
            [(selection)]="selectedSpecialists"
            dataKey="id"
            selectionMode="multiple"
            [rowHover]="true"
            [tableStyle]="{ 'min-width': '50rem' }"
        >
            <ng-template pTemplate="caption">
                <div class="flex justify-content-end align-content-center flex-wrap">
                    <p-button
                        [label]="'Añadir Especialistas a ' + clinic?.name"
                        (click)="addToClinic()"
                        [loading]="loading"
                        icon="pi pi-plus"
                        onKeyPress=""
                    />
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col" style="width: 4rem">
                        <p-tableHeaderCheckbox />
                    </th>
                    <th scope="col">Id</th>
                    <th scope="col" pSortableColumn="name">
                        Especialista
                        <p-sortIcon field="name"></p-sortIcon>
                    </th>

                    <th scope="col">Especialidad</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="row"></p-tableCheckbox>
                    </td>
                    <td>{{ row.id }}</td>
                    <td>
                        <ng-container *ngIf="row.imageUrl; else noDataImage">
                            <p-avatar
                                [image]="row.imageUrl"
                                shape="circle"
                                [style]="{ 'background-color': '#00929c', color: '#fff', 'vertical-align': 'middle' }"
                            />
                        </ng-container>
                        <ng-template #noDataImage>
                            <p-avatar
                                [style]="{ 'background-color': '#00929c', color: '#fff', 'vertical-align': 'middle' }"
                                [label]="row.name.charAt(0).toUpperCase()"
                                shape="circle"
                            />
                        </ng-template>
                        <span class="image-text ml-2">{{ row.name }}</span>
                    </td>
                    <td>{{ row.specialty }}</td>
                </tr>
            </ng-template>
        </p-table>
    }
    @if (specialistsToAdd?.length === 0) {
        <div class="flex h-full flex-wrap align-items-center justify-content-center">
            <h4 class="text-center">No hay especialistas para agregar</h4>
        </div>

    }
</p-dialog>

<p-dialog [(visible)]="deleteModal" header="Cofirmar" [modal]="true" [style]="{ width: '450px' }">
    <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem"></i>
        <span *ngIf="specialist"
        >¿Estás seguro de que quieres desvincular a <b>{{ specialist.name }}</b> de la clínica?</span
        >
    </div>
    <ng-template pTemplate="footer">
        <button
            pButton
            pRipple
            icon="pi pi-times"
            class="p-button-text"
            label="No"
            (click)="deleteModal = false"
        ></button>
        <button
            pButton
            [loading]="loading"
            pRipple
            icon="pi pi-check"
            class="p-button-text"
            label="Sí"
            (click)="confirmDelete()"
        ></button>
    </ng-template>
</p-dialog>
